import type { TokenBatchModel } from '@/models/TokenBatch/Model'
import TokenBatchsApi from '@/models/TokenBatch/Api'
import DetailsState from '@/helpers/models/DetailsState'
import ListState from '@/helpers/models/ListState'
import type { LaravelPaginationResponse } from '@/interfaces/models/Laravel'

export class TokenBatchDetailsState extends DetailsState<TokenBatchsApi, TokenBatchModel> {
	api = new TokenBatchsApi()
}

export function useTokenBatchDetailsState() {
	return new TokenBatchDetailsState()
}

export class TokenBatchListState extends ListState<
	TokenBatchsApi,
	TokenBatchModel,
	LaravelPaginationResponse<TokenBatchModel>
> {
	api = new TokenBatchsApi()
}

export function useTokenBatchListState() {
	return new TokenBatchListState()
}
